import { useQuery } from 'react-query';
import http from '../config/http-service';
import type { MasterProduct } from './types';
import { masterProductsEndpoint } from './use-get-master-products-api';

// GET ums/v1/cms/master-products/:id
export const useGetMasterProductApi = (id?: number, options: { enabled?: boolean } = {}) => {
  return useQuery({
    // 'detail' segment avoids colliding with the by-family list key
    // [endpoint, familyId] — product ids and family ids can overlap.
    queryKey: [masterProductsEndpoint, 'detail', id],
    queryFn: async (): Promise<MasterProduct> => {
      const { data } = await http.get(`${masterProductsEndpoint}/${id}`);
      // The API wraps the resource in an envelope: { data: {...} }. Returning
      // it unwrapped seeds the wizard's edit mode; the envelope itself made
      // every seeded field undefined (blank "edit" form bug).
      return data?.data ?? data;
    },
    enabled: options.enabled ?? !!id,
  });
};
